import client from "./client";

const stepCard = (card = {}) => ({
  n: card.n || "",
  title: card.title || "",
  description: card.description || "",
});

const officeCard = (card = {}) => ({
  country: card.country || "",
  city: card.city || "",
  badge: card.badge || "",
  address: card.address || "",
  phone: card.phone || "",
  email: card.email || "",
  hours: card.hours || "",
  lat: card.lat || "",
  lon: card.lon || "",
});

const TEXT_KEYS = [
  "nextTag",
  "nextTitleLead",
  "nextTitleAccent",
  "nextTitleTail",
  "nextBody",
  "formTitleLead",
  "formTitleLead2",
  "formTitleAccent",
  "formConsentPre",
  "formConsentLink",
  "formConsentHref",
  "officesTag",
  "officesTitleLead",
  "officesTitleAccent",
  "officesBody",
];

const BOOL_KEYS = ["nextHide", "formHide", "officesHide"];
const STEP_KEYS = ["nextStep1", "nextStep2", "nextStep3"];
const OFFICE_KEYS = ["office1", "office2"];

export function prepareContactPage(form = {}) {
  const payload = {};

  TEXT_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = form[key] ?? "";
  });
  BOOL_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = !!form[key];
  });

  STEP_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = stepCard(form[key]);
  });
  OFFICE_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = officeCard(form[key]);
  });

  return payload;
}

export const getContactPage = () => client.post("/contactpage/getPage");
export const addContactPage = (payload) =>
  client.post("/contactpage/addpage", payload);
export const updateContactPage = (payload) =>
  client.post("/contactpage/updatePage", payload);
